import {
  Avatar,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React, { createRef } from "react";
import { colors } from "../../theme/colors";
import {
  CheckCircleOutlineOutlined,
  FileDownloadOutlined,
  Storefront,
} from "@mui/icons-material";
import {
  SectionWrapper,
  StyledCardAmount,
  StyledProductWrapper,
} from "./styled";
import { ProductWrapper } from "../Shop/styled";
import { StyledShopName } from "../Catalog/styled";
import { getInitials } from "../../utils/functions";
import { useNavigate } from "react-router-dom";
import { createFileName, useScreenshot } from "use-react-screenshot";

export default function Result({ product, beneficiarie, va, result }) {
  const navigate = useNavigate();
  const wrapperRef = createRef(null);
  const [img, takeScreenShot] = useScreenshot({
    type: "image/jpeg",
    quality: 1.0,
  });

  const download = (
    image,
    {
      name = `PayBi-${product.voucherName}-${
        new Date().toISOString().split("T")[0]
      }`,
      extension = "jpg",
    } = {}
  ) => {
    const a = document.createElement("a");
    a.href = image;
    a.download = createFileName(extension, name);
    a.click();
  };

  const downloadScreenShot = () =>
    takeScreenShot(wrapperRef.current).then(download);

  return (
    <Box ref={wrapperRef}>
      <div style={{ width: "80vw", margin: "auto", maxWidth: "812px" }}>
        <Divider sx={{ marginTop: "1rem", marginBottom: "1rem" }} />

        <Grid
          container
          justifyContent="center"
          direction="column"
          alignItems="center"
        >
          <Grid item>
            <Typography
              variant="h4"
              style={{ color: colors.green.main }}
              textAlign="center"
            >
              Pago realizado satisfactoriamente
            </Typography>
          </Grid>
          <Grid item>
            <CheckCircleOutlineOutlined
              color="success"
              style={{ fontSize: "64px" }}
            />
          </Grid>
        </Grid>

        <StyledProductWrapper container direction="column">
          <Grid item>
            <Grid container textAlign="start">
              <Grid item md={4} textAlign="start">
                {product.brandImage ? (
                  <Avatar
                    sx={{
                      width: 80,
                      height: 80,
                      margin: "0.5rem",
                      "@media screen and (max-width: 600px)": {
                        width: 40,
                        height: 40,
                      },
                    }}
                    src={product.brandImage}
                  />
                ) : (
                  <StyledShopName
                    style={{
                      width: 80,
                      height: 80,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0.5rem auto auto 0.5rem",
                    }}
                  >
                    <span>{getInitials(product.partner)}</span>
                  </StyledShopName>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            {product.productType === "PRODUCT" ? (
              <ProductWrapper hasImage={product.voucherImage} size="150px">
                {product.voucherImage ? (
                  <img
                    src={product.voucherImage}
                    alt={product.voucherName}
                    style={{ maxWidth: "100%" }}
                  />
                ) : (
                  <Storefront
                    sx={{
                      fontSize: { sm: "5rem", xs: "3rem" },
                      color: colors.white.main,
                    }}
                  />
                )}
              </ProductWrapper>
            ) : (
              <StyledCardAmount>
                {"Q "}
                {product.productType === "RANGE_AMOUNT" ? va : product.price}
              </StyledCardAmount>
            )}
            <div style={{ color: colors.white.main, marginTop: "0.5rem" }}>
              {product.voucherName}
            </div>
          </Grid>
        </StyledProductWrapper>
      </div>

      <div style={{ width: "80vw", margin: "2rem auto", maxWidth: "812px" }}>
        <SectionWrapper>
          <Grid container spacing={5} alignItems="center">
            <Grid item lg={4} xs={4}>
              {product.brandImage ? (
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    margin: "0.5rem",
                  }}
                  src={product.brandImage}
                />
              ) : (
                <StyledShopName
                  style={{
                    width: 80,
                    height: 80,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span>{getInitials(product.partner)}</span>
                </StyledShopName>
              )}
            </Grid>
            <Grid item lg={8} xs={8}>
              <Typography variant="h3">
                Q {product.productType === "RANGE_AMOUNT" ? va : product.price}
              </Typography>
              <Typography variant="h5" fontWeight="bold">
                {product.voucherName}
              </Typography>
            </Grid>
          </Grid>
        </SectionWrapper>

        <SectionWrapper>
          <Grid container spacing={5} alignItems="center">
            <Grid item lg={4} xs={4}>
              <Typography variant="h3">Datos del beneficiario</Typography>
            </Grid>
            <Grid item lg={8} xs={8}>
              <Typography variant="h5" fontWeight={"bold"}>
                {beneficiarie.name} {beneficiarie.surname}
              </Typography>
              <Typography variant="h5">{`+502 ${beneficiarie.phone}`}</Typography>
              <Typography variant="h5">{beneficiarie.email}</Typography>
            </Grid>
          </Grid>
        </SectionWrapper>

        <SectionWrapper>
          <Typography
            variant="h3"
            fontWeight="bold"
            style={{ marginBottom: "1rem" }}
          >
            Detalle del vale
          </Typography>
          <Grid container>
            <Grid item md={6} xs={12}>
              <Typography
                variant="h5"
                fontWeight="bold"
                style={{ marginBottom: "0.25rem" }}
              >
                OKY VALE
              </Typography>
              <Typography variant="h5" style={{ marginTop: "0.25rem" }}>
                {result.oky.data.code}
              </Typography>{" "}
            </Grid>
            <Grid item md={6} xs={12}>
              <Typography
                variant="h5"
                fontWeight="bold"
                style={{ marginBottom: "0.25rem" }}
              >
                Vencimiento
              </Typography>
              <Typography variant="h5" style={{ marginTop: "0.25rem" }}>
                {String(result.oky.data.dateExpiration).replaceAll("-", "/")}
              </Typography>{" "}
            </Grid>
            <Grid item md={6} xs={12}>
              <Typography
                variant="h5"
                fontWeight="bold"
                style={{ marginBottom: "0.25rem" }}
              >
                No. de autorización
              </Typography>
              <Typography variant="h5" style={{ marginTop: "0.25rem" }}>
                {result.ebi.data.authorization}
              </Typography>{" "}
            </Grid>
            <Grid item md={6} xs={12} sx={{ wordWrap: "break-word" }}>
              <Typography
                variant="h5"
                fontWeight="bold"
                style={{ marginBottom: "0.25rem" }}
              >
                Enlace
              </Typography>
              <Typography
                sx={{
                  fontSize: "24px",
                  color: colors.secondary,
                  "&:hover": { textDecoration: "underline", cursor: "pointer" },
                  "@media screen and (max-width: 450px)": {
                    fontSize: "1rem",
                  },
                }}
                onClick={() => window.open(result.oky.data.shortUrl, "_blank")}
              >
                {result.oky.data.shortUrl}
              </Typography>
            </Grid>
          </Grid>
        </SectionWrapper>

        <Button
          sx={{
            display: "flex",
            flexDirection: "column",
            fontSize: "24px",
            margin: "2rem auto",
            textTransform: "capitalize",
            "&:hover": { color: colors.secondary, textDecoration: "underline" },
          }}
          onClick={downloadScreenShot}
        >
          <FileDownloadOutlined style={{ fontSize: "48px" }} />
          Descarga
        </Button>

        <Grid
          container
          justifyContent="center"
          direction="column"
          alignItems="center"
          textAlign="center"
          width={"90%"}
          margin={"auto"}
          spacing={1}
        >
          <Grid item>
            <Typography variant="h5">
              <span style={{ fontWeight: "bold", color: colors.primary }}>
                Atención:{" "}
              </span>{" "}
              Este no es el vale de regalo canjeable, ese ya fue enviado al
              beneficiario o ingresa al link para verlo
            </Typography>
          </Grid>

          <Grid item>
            <Typography
              variant="h5"
              sx={{ marginBottom: "0.5rem" }}
              fontWeight={"bold"}
            >
              ¿Deseas enviar otro vale?
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                color: colors.secondary,
                "&:hover": { textDecoration: "underline", cursor: "pointer" },
                "@media screen and (max-width: 600px)": {
                  fontSize: "1rem",
                },
              }}
              onClick={() => {
                navigate("../../");
                window.scrollTo(0, 0);
              }}
            >
              Regresa al inicio
            </Typography>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
}
